<ng-template #preHeader>
    SIGN IN / SIGN UP
</ng-template>
<shared-auth-header [preHeader]="preHeader" [description]="description">
    Hey there!
</shared-auth-header>
<ng-template #description>
    Please enter your mobile phone number. This will be used for a secure sign in or to start a new profile.
</ng-template>

<shared-form-for-cell-sign-in [modal]="true"></shared-form-for-cell-sign-in>